import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { FreeMode, Autoplay } from "swiper";
import student1 from '../../img/students/student-1.jpeg';
import student2 from '../../img/students/student-2.jpeg';
import student3 from '../../img/students/student-3.jpeg';
import student4 from '../../img/students/student-4.jpeg';
import student5 from '../../img/students/student-5.jpeg';
import student6 from '../../img/students/student-6.jpeg';
import student7 from '../../img/students/student-7.jpeg';

const StudentTestimonial = () => {
    const studentsFeedback = [
        { _id: 1, name: 'Shashwat Aggarwal', description: 'Career Hikers is amazing platform for all solving any issue related to your career, they help and guide in an effective and easier way. In one word, Satisfied!', img: student1 },
        { _id: 2, name: 'AHarmandeeo kaur', description: "It's a wonderful guide which covers different fields of career. It's easy to use app which feed you with knowledgeable content daily:)", img: student2 },
        { _id: 3, name: 'Miss Myra', description: "A helpful app for students and working professionals. Easy to use and covers multiple things.", img: student3 },
        { _id: 4, name: 'Ankush singharia', description: "Counseling session was excellent. It gives very clear picture of what would be the right strategy to be followed to achieve your goal.l really like this app...", img: student4 },
        { _id: 5, name: 'Krish Singh', description: "It is a very useful app for guiding students.. there r so many interesting tests, articles and videos that will surely help students to choose right direction :)", img: student5 },
        { _id: 6, name: 'Aman Garg', description: "My experience with Career Hikers was very awesome. This app helped me choose a right career plan for my self. This is an excellent app where everyone get guidance of all streams and career options......", img: student6 },
        { _id: 7, name: 'Tushar Garg', description: "This app has some real good content and the best counselllors who will guide you with you career related doubts. This app helps you to book your session with the best counsellors and have live sessions with them. Really it's a very good app and thanks for helping others get education with their career.", img: student7 },
        // { _id: 8, name: 'Subham ', description: "Career Hikers is an amazing platform that helps students across different streams to fulfill their career aspirations through their amicable approach. Also, the app has super user-friendly interface that makes it even easier to use.", img: student8 },
        // { _id: 9, name: 'Rashi Mishra', description: "It is a great app for education guidance. Great career counsellors here to guide you through each and every aspect of your doubts regarding your career. Overall it is a great app for learning, education and for making a right choice for your career.", img: student9 },
    ];

    return (
        <div className='mb-4 p-10'>
            <h1 className='md:text-6xl text-center text-4xl font-semibold text-green-500'>Testimonials</h1>
            <h4 className='md:text-xl text-sm text-center mt-2 px-10'><span className='text-orange-400'>Mentor</span> suggest it and <span className='text-blue-400'>students adore</span> it.</h4>
            <div className='flex justify-center mt-8 px-4'>
                <button className='border border-slate-800 rounded-tl-full rounded-bl-full rounded-tr-full rounded-br-full bg-white py-2 px-10 text-slate-800 text-2xl hover:bg-slate-800 hover:text-white'>Student</button>

                <button className='border border-green-500 ml-4 rounded-tl-full rounded-bl-full rounded-tr-full rounded-br-full bg-white py-2 px-10 text-green-500 text-2xl hover:bg-green-500 hover:text-white'>Mentor</button>
            </div>
            <Swiper
                breakpoints={{
                    // when window width is >= 640px
                    640: {
                        width: 640,
                        slidesPerView: 1,
                    },
                    // when window width is >= 768px
                    768: {
                        width: 768,
                        slidesPerView: 3,
                    },
                    1024: {
                        width: 1024,
                        slidesPerView: 3,
                    },
                }}
                slidesPerView={1}
                spaceBetween={10}
                freeMode={true}
                pagination={{
                    clickable: true,
                }}
                autoplay={{ delay: 3000 }}
                modules={[FreeMode, Autoplay]}
                className=""
            >
                {
                    studentsFeedback?.map((student, i) => <SwiperSlide key={i} className='p-4 cursor-pointer mt-8'>
                        <img src={student?.img} alt="" className="rounded-full w-full h-72" />
                        <div className="mt-3">
                            <p className="text-2xl font-semibold text-center">{student?.name}</p>
                            <h4 className="text-sm font-semibold text-center">{student?.description}</h4>
                        </div>
                    </SwiperSlide>)
                }
            </Swiper>
        </div>
    );
};

export default StudentTestimonial;